module.exports = __webpack_public_path__ + "static/media/206_SHOT_339.a2330869.webp";